import sc from "constants/locales/sc"
import { ascend, path } from "ramda"
import { isNotEmptyString, isset } from "utils/validate"
import en from "./en"
import tc from "./tc"

const locales = {
  en: {
    key: "en",
    name: "English",
    shortName: "EN",
    strings: en,
    calendarLocale: "en",
    valuePath: {
      nameTitle: ["englishDescription"],
      country: ["name", "en"],
      natureOfBusiness: ["englishDescription"],
      reCaptureLocale: "en",
      summaryMergeNameFunc: (salutation, firstName, lastName) => ({
        salutation: isset(salutation) && isNotEmptyString(salutation) ? `${salutation}.` : null,
        firstName: isset(firstName) && isNotEmptyString(firstName) ? `${firstName}` : null,
        lastName: isset(lastName) && isNotEmptyString(lastName) ? `${lastName}` : null
      }),
      summaryCountry: ["customer", "countryName", "en"],
      summaryProvince: ["customer", "provinceName", "en"],
      summaryCity: ["customer", "cityName", "en"],
      packageName: ["nameEN"],
      packageDescription: ["descriptionEN"],
      fairName: ["nameEN"]
    },
    countryListCompare: ascend(path(["name", "en"]))
  },
  tc: {
    key: "tc",
    name: "繁體中文",
    shortName: "繁",
    strings: tc,
    calendarLocale: "zh-Hant",
    valuePath: {
      nameTitle: ["chineseDescription"],
      country: ["name", "zh"],
      natureOfBusiness: ["chineseDescription"],
      reCaptureLocale: "zh-HK",
      summaryMergeNameFunc: (salutation, firstName, lastName) => ({
        lastName: isset(lastName) && isNotEmptyString(lastName) ? `${lastName}` : null,
        firstName: isset(firstName) && isNotEmptyString(firstName) ? `${firstName}` : null,
        salutation: isset(salutation) && isNotEmptyString(salutation) ? `${salutation}` : null
      }),
      summaryCountry: ["customer", "countryName", "zh"],
      summaryProvince: ["customer", "provinceName", "zh"],
      summaryCity: ["customer", "cityName", "zh"],
      packageName: ["nameTC"],
      packageDescription: ["descriptionTC"],
      fairName: ["nameTC"]
    },
    countryListCompare: (a, b) => {
      const priority = ["HKG", "CHN"]
      const aCode = path(["id"], a)
      const bCode = path(["id"], b)
      const aPriority = priority.findIndex((p) => aCode.includes(p))
      const bPriority = priority.findIndex((p) => bCode.includes(p))
      if (aPriority !== -1 || bPriority !== -1) {
        return (aPriority === -1 ? Infinity : aPriority) - (bPriority === -1 ? Infinity : bPriority)
      }
      const aName = path(["name", "en"], a)
      const bName = path(["name", "en"], b)
      return aName.localeCompare(bName)
    }
  },
  sc: {
    key: "sc",
    name: "简体中文",
    shortName: "简",
    strings: sc,
    calendarLocale: "zh-Hans",
    valuePath: {
      nameTitle: ["chineseDescriptionSC"],
      country: ["name", "sc"],
      natureOfBusiness: ["chineseDescriptionSC"],
      summaryMergeNameFunc: (salutation, firstName, lastName) => ({
        lastName: isset(lastName) && isNotEmptyString(lastName) ? `${lastName}` : null,
        firstName: isset(firstName) && isNotEmptyString(firstName) ? `${firstName}` : null,
        salutation: isset(salutation) && isNotEmptyString(salutation) ? `${salutation}` : null
      }),
      summaryCountry: ["customer", "countryName", "sc"],
      summaryProvince: ["customer", "provinceName", "sc"],
      summaryCity: ["customer", "cityName", "sc"],
      packageName: ["nameSC"],
      packageDescription: ["descriptionSC"],
      fairName: ["nameSC"]
    },
    countryListCompare: (a, b) => {
      const priority = ["HKG", "CHN"]
      const aCode = path(["id"], a)
      const bCode = path(["id"], b)
      const aPriority = priority.findIndex((p) => aCode.includes(p))
      const bPriority = priority.findIndex((p) => bCode.includes(p))
      if (aPriority !== -1 || bPriority !== -1) {
        return (aPriority === -1 ? Infinity : aPriority) - (bPriority === -1 ? Infinity : bPriority)
      }
      const aName = path(["name", "en"], a)
      const bName = path(["name", "en"], b)
      return aName.localeCompare(bName)
    }
  }
  // more
}

const DEFAULT_LOCALE = locales.en.key

const localeOptions = Object.values(locales).map((locale) => ({
  value: locale.key,
  shortName: locale.shortName,
  label: locale.name
}))

export default locales
export { localeOptions, DEFAULT_LOCALE }
